import { useState } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function CBInput({ salesArray, setSalesArray, cbsArray, setCbsArray, cbColorHighlight }) {

  const [sales, setSales] = useState(0)
  const [cb, setCb] = useState(0)

  function handleSales(e) {
    const int = Number(e.target.value)
    setSales(int)
    setSalesArray([...salesArray, int])
  }

  function handleCb(e) {
    const int = Number(e.target.value)
    setCb(int)
    setCbsArray([...cbsArray, int])
  }

  return (
    <Row>
      <Col className='calcColMonth colGroup p-3 m-2 rounded'>
        <select name="month" className='calcInput' >
          <option disabled selected value></option>
          <option value="1">01 - January</option>
          <option value="2">02 - February</option>
          <option value="3">03 - March</option>
          <option value="4">04 - April</option>
          <option value="5">05 - May</option>
          <option value="6">06 - June</option>
          <option value="7">07 - July</option>
          <option value="8">08 - August</option>
          <option value="9">09 - September</option>
          <option value="10">10 - October</option>
          <option value="11">11 - November</option>
          <option value="12">12 - December</option>
        </select>
      </Col>
      <Col xs={3} className='calcCol colGroup p-3 m-2 rounded'>
        <input type="text" name="notes" className='calcInput' autpcomplete='off' />
      </Col>
      <Col className='calcCol colGroup p-3 m-2 rounded'>
        <input type="text" name="sales" onChange={handleSales} className='calcInput sales' autpcomplete='off' />
      </Col>
      <Col className='calcCol colGroup p-3 m-2 rounded'>
        <input type="text" name="cb" onChange={handleCb} className='calcInput chargebacks' autpcomplete='off' />
      </Col>
      <Col xs={2} className={`calcCol colGroup p-3 m-2 rounded ${cbColorHighlight((cb/sales)*100)}`}>
        <span>%</span>
        <span>{cb && sales && ((cb/sales)*100).toFixed(2)}</span>
      </Col>
      
    </Row>
  )
}

export default CBInput